import React from 'react';
import './LongTermScheduleCalendar.scss';
import moment from 'moment';
import LtsDayCell from './LtsDayCell';

export default class LtsCalendarGrid extends React.Component {
    getSplitIntoWeeks = () => {
        const { days } = this.props;

        const weeks = [];
        let current = [];

        days.forEach((d) => {
            if (moment(d).day() === 0 && current.length > 0) {
                weeks.push(current);
                current = [];
            }
            current.push(d);
        });

        if (current.length) {
            weeks.push(current);
        }

        return weeks;
    };

    render() {
        const weeks = this.getSplitIntoWeeks();

        return (
            <div className="lts-calendar-wrap">
                <div className="lts-calendar-grid">
                    {weeks.map((weekDays, wi) => {
                        const startDow = moment(weekDays[0]).day();
                        const endDow = moment(
                            weekDays[weekDays.length - 1]
                        ).day();

                        return (
                            <div
                                key={wi}
                                className={`lts-week-row${wi === 0 ? ' lts-first-row' : ''}`}
                            >
                                {Array.from({ length: startDow }).map(
                                    (_, i) => (
                                        <div
                                            key={`pre-${i}`}
                                            className="lts-day-cell lts-empty"
                                        />
                                    )
                                )}
                                {weekDays.map((dateStr) => (
                                    <LtsDayCell
                                        key={`${dateStr}-${wi}`}
                                        dateStr={dateStr}
                                        {...this.props}
                                    />
                                ))}
                                {Array.from({ length: 6 - endDow }).map(
                                    (_, i) => (
                                        <div
                                            key={`post-${i}`}
                                            className="lts-day-cell lts-empty"
                                        />
                                    )
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}
